import axios from 'axios'


const api = axios.create({
  baseURL: "https://recruit.www.he-service.co.jp/",
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  }
})

export default api
